module.exports = __webpack_public_path__ + "img/13.c3e47431.webp";